import { getSessionUUID } from '../components/lib/AuthToken'; // Import the utility function
import logger from "../utils/logger";

const addressBookRequest = async (path = '', method = 'GET', data = null) => {
    try {
        const sessionToken = await getSessionUUID();
        const response = await fetch(`/customers/address_book${path}`, {
            method,
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${sessionToken}` },
            ...(data ? { body: JSON.stringify(data) } : {}),
        });
        const responseBody = await response.json();
        return { status: response.status, data: responseBody };
    } catch (err) {
        logger.error('Address book request failed:', err);
        return { status: 500, data: { error: err.message || 'An error occurred' } };
    }
};

export const fetch_address_book = () => addressBookRequest();
export const add_address_book_entry = (address) => addressBookRequest('', 'POST', address);
export const update_address_book_entry = (address) => addressBookRequest(`/${address.id}`, 'PUT', address);
export const delete_address_book_entry = (addressId) => addressBookRequest(`/${addressId}`, 'DELETE');

const palletNetworkRequest = async (path = '', method = 'GET', data = null) => {
    try {
        const sessionToken = await getSessionUUID();
        const response = await fetch(`/customers/pallet_network_costs${path}`, {
            method,
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${sessionToken}` },
            ...(data ? { body: JSON.stringify(data) } : {}),
        });
        const responseBody = await response.json();
        return { status: response.status, data: responseBody };
    } catch (err) {
        logger.error('Pallet network pricing request failed:', err);
        return { status: 500, data: { error: err.message || 'An error occurred' } };
    }
};

export const fetch_pallet_network_costs = () => palletNetworkRequest();
export const save_pallet_network_costs = (costs) => palletNetworkRequest('', 'PUT', costs);
export const delete_pallet_network_costs = (customerId) => palletNetworkRequest(`/${customerId}`, 'DELETE');



export const fetch_all_customers = async () => {
    
    try {

        const sessionToken = await getSessionUUID(); // Use the utility function

        // Options to send data to backend
        const requestOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
        };

        // Send Request to backend
        const response = await fetch('/customers/get_all_customers', requestOptions);
        
        // Check if response is ok before trying to parse JSON
        if (!response.ok) {
            logger.error(`HTTP error! status: ${response.status}`);
            const errorText = await response.text();
            logger.error('Error response body:', errorText);
            return {
                message: `HTTP error! status: ${response.status}`,
                status: response.status,
                data: null
            };
        }

        // Check if response is JSON
        const contentType = response.headers.get('content-type');
        if (!contentType || !contentType.includes('application/json')) {
            const textResponse = await response.text();
            logger.error('Non-JSON response:', textResponse);
            return {
                message: 'Server returned non-JSON response',
                status: response.status,
                data: null
            };
        }

        const responseBody = await response.json();

        // Return the message and status
        return {
            message: 'Request successful',
            status: response.status,
            data: responseBody || null, // Include data if provided
        };
    } catch (err) {
        logger.error("Error fetching customers:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
};

//-------------------------------------------------------------------------------------------------

export const add_new_customer = async (customer) => {

    try {

        const sessionToken = await getSessionUUID(); // Use the utility function

        // Options to send data to backend
        const requestOptions = {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
            body: JSON.stringify({ customer })
        };

        // Send Request to backend
        const response = await fetch('/customers/add_new_customer', requestOptions);
        const responseBody = await response.json();

        // Return the message and status
        return {
            message: 'Request successful',
            status: response.status,
            data: responseBody || null, // Include data if provided
        };
    } catch (err) {
        logger.error("Error adding route:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
};

//-------------------------------------------------------------------------------------------------

export const update_customer = async (customer_data) => {
    try {

        const sessionToken = await getSessionUUID(); // Use the utility function

        // Options to send data to backend
        const requestOptions = {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
            body: JSON.stringify({ customer_data })
        };

        // Send Request to backend
        const response = await fetch('/customers/update_customer', requestOptions);
        const responseBody = await response.json();

        // Return the message and status
        return {
            message: 'Request successful',
            status: response.status,
            data: responseBody || null, // Include data if provided
        };
    } catch (err) {
        logger.error("Error updating customer:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
};

//-------------------------------------------------------------------------------------------------

export const add_route = async (route) => {

    try {

        const sessionToken = await getSessionUUID(); // Use the utility function

        // Options to send data to backend
        const requestOptions = {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
            body: JSON.stringify({ route })
        };

        // Send Request to backend
        const response = await fetch('/customers/add_route', requestOptions);
        const responseBody = await response.json();

        // Return the message and status
        return {
            message: 'Request successful',
            status: response.status,
            data: responseBody || null, // Include data if provided
        };
    } catch (err) {
        logger.error("Error adding route:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
};

//-------------------------------------------------------------------------------------------------

export const edit_route = async (route) => {
    
    try {

        const sessionToken = await getSessionUUID(); // Use the utility function

        // Options to send data to backend
        const requestOptions = {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
            body: JSON.stringify({ route })
        };

        // Send Request to backend
        const response = await fetch('/customers/edit_route', requestOptions);
        const responseBody = await response.json();

        // Return the message and status
        return {
            message: 'Request successful',
            status: response.status,
            data: responseBody || null, // Include data if provided
        };
    } catch (err) {
        logger.error("Error adding route:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
};

//-------------------------------------------------------------------------------------------------
// customer_deliveries — new delivery-point system
//-------------------------------------------------------------------------------------------------

export const fetch_all_customer_deliveries = async () => {
    try {
        const sessionToken = await getSessionUUID();
        const response = await fetch('/customers/get_all_customer_deliveries', {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${sessionToken}` },
        });
        const responseBody = await response.json();
        return { message: 'Request successful', status: response.status, data: responseBody || null };
    } catch (err) {
        logger.error("Error fetching all customer deliveries:", err);
        return { message: err.message || 'An error occurred', status: 500 };
    }
};

export const fetch_customer_deliveries = async (customer_id) => {
    try {
        const sessionToken = await getSessionUUID();
        const response = await fetch(`/customers/get_customer_deliveries/${customer_id}`, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${sessionToken}` },
        });
        const responseBody = await response.json();
        return { message: 'Request successful', status: response.status, data: responseBody || null };
    } catch (err) {
        logger.error("Error fetching customer deliveries:", err);
        return { message: err.message || 'An error occurred', status: 500 };
    }
};

export const add_customer_delivery = async (delivery) => {
    try {
        const sessionToken = await getSessionUUID();
        const response = await fetch('/customers/add_customer_delivery', {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${sessionToken}` },
            body: JSON.stringify({ delivery }),
        });
        const responseBody = await response.json();
        return { message: 'Request successful', status: response.status, data: responseBody || null };
    } catch (err) {
        logger.error("Error adding customer delivery:", err);
        return { message: err.message || 'An error occurred', status: 500 };
    }
};

export const edit_customer_delivery = async (delivery) => {
    try {
        const sessionToken = await getSessionUUID();
        const response = await fetch('/customers/edit_customer_delivery', {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${sessionToken}` },
            body: JSON.stringify({ delivery }),
        });
        const responseBody = await response.json();
        return { message: 'Request successful', status: response.status, data: responseBody || null };
    } catch (err) {
        logger.error("Error editing customer delivery:", err);
        return { message: err.message || 'An error occurred', status: 500 };
    }
};

export const delete_customer_delivery = async (delivery) => {
    try {
        const sessionToken = await getSessionUUID();
        const response = await fetch('/customers/delete_customer_delivery', {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${sessionToken}` },
            body: JSON.stringify({ delivery }),
        });
        const responseBody = await response.json();
        return { message: 'Request successful', status: response.status, data: responseBody || null };
    } catch (err) {
        logger.error("Error deleting customer delivery:", err);
        return { message: err.message || 'An error occurred', status: 500 };
    }
};

export const delete_route = async (route) => {
    try {
        const sessionToken = await getSessionUUID();
        const requestOptions = {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${sessionToken}` },
            body: JSON.stringify({ route })
        };
        const response = await fetch('/customers/delete_route', requestOptions);
        const responseBody = await response.json();
        return { message: 'Request successful', status: response.status, data: responseBody || null };
    } catch (err) {
        logger.error("Error deleting route:", err);
        return { message: err.message || 'An error occurred', status: 500 };
    }
};